import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white w-full aspect-5/4 @container" }
const _hoisted_2 = { class: "p-3 @md:p-4 h-full flex flex-col gap-3 @md:gap-4" }
const _hoisted_3 = { class: "flex-1 relative" }




export default /*@__PURE__*/_defineComponent({
  __name: 'BeforeAfter',
  props: {
    before: {
        type: String,
        required: true,
    },
    after: {
        type: String,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "bg-brand italic font-light font-brand text-2xl p-2 @md:text-3xl @md:p-3" }, [
        _createElementVNode("span", { class: "font-black" }, "POSLEDNIK"),
        _createTextVNode(" WIR LACKEN DAS ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          style: _normalizeStyle({ backgroundImage: `url(${__props.before})` }),
          class: "BeforeAfter__before w-[55%] h-full bg-center bg-cover absolute top-0 left-0"
        }, null, 4),
        _createElementVNode("div", {
          style: _normalizeStyle({ backgroundImage: `url(${__props.after})` }),
          class: "BeforeAfter__after w-[55%] h-full bg-center bg-cover absolute top-0 right-0"
        }, null, 4)
      ])
    ])
  ]))
}
}

})